// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"aae33379","224":"8dd4e7ea","355":"9cecf610","468":"71d46aa6","546":"5154a783","625":"e2d724fa"}[chunkId] + ".chunk.css";
};